import { useState } from 'react'
import { Button } from '@components/v2/button'
import { Input } from '@components/v2/input'
import { Modal } from '@components/v2/modal'
import { t } from '@lingui/core/macro'

interface ColumnModalProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  insertColumn: any
}

export function NewColumnModal({ isOpen, setIsOpen, insertColumn }: ColumnModalProps) {
  const [name, setName] = useState('')

  return (
    <Modal.Container
      isOpen={isOpen}
      onClickOutside={() => {
        setIsOpen(false)
      }}
      className="px-10 py-8 max-w-[500px]"
    >
      <h2 className="text-[18px] font-bold mb-9">{t`Insert a new column`}</h2>

      <Input
        label={t`Column name`}
        placeholder={t`Name`}
        id="name"
        message={t`We recommend a name that has all important identifiable details.`}
        className="max-w-[350px] w-full"
        onChange={e => {
          setName(e.target.value)
        }}
        value={name}
      />

      <Modal.Footer>
        <Button
          variant="dark"
          loadingText={t`Creating Column...`}
          type="submit"
          onClick={() => {
            insertColumn({ name })
            setName('')
          }}
        >
          {t`Insert column`}
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            insertColumn({ name, addAnother: true })
            setName('')
          }}
        >
          {t`Insert column & add another`}
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            setIsOpen(false)
          }}
        >
          {t`Discard`}
        </Button>
      </Modal.Footer>
    </Modal.Container>
  )
}
